import { render, staticRenderFns } from "./relate-product.vue?vue&type=template&id=7903ce81&scoped=true&"
import script from "./relate-product.vue?vue&type=script&lang=js&"
export * from "./relate-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903ce81",
  null
  
)

export default component.exports